var map = {
	"./ANYMARKET_BANNER.png": "1304",
	"./CONSIGNET_BANNER.png": "0cd7",
	"./DB1GLOBAL_BANNER.png": "5941",
	"./DB1GROUP_BANNER.png": "330d",
	"./DUCZ_BANNER.png": "875e",
	"./KONCILI_BANNER.png": "6864",
	"./MIXTRA_BANNER.png": "f74f",
	"./PREDIZE_BANNER.png": "cf0c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "64a5";